/**Dependencies */
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
/**Componentes */
import { Row, Col, Button, Accordion, Modal, Form } from "react-bootstrap";
import { SectionAdvise } from "../components/SectionAdvise";
import { Link, useLocation } from "react-router-dom";
import { SearchEngine } from "../components/SearchEngine";
import { CardResultHotel } from "../components/CardResultHotel";

/**Styles */
import "../styles/hotel.scss";

/**Images */
import bannerLuckyDay from "../images2/banner-lucky-day.png";
import { fetchMarkup } from "../helpers";
import {
  getHotelAvailability,
  getHotelFilters,
  getHotels,
} from "../services/searchService";
import { Loader } from "../components/Loader";
import { IoIosArrowDown } from "react-icons/io";
import { FaStar } from "react-icons/fa";

export const Alojamientos = () => {
  const [hotels, setHotels] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);
  const [loading, setLoading] = useState(true); // Indicador de carga
  const [visibleCount, setVisibleCount] = useState(10); // Contador de resultados visibles
  const [filters, setFilters] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [totalNights, setTotalNights] = useState(0);
  const [totalRooms, setTotalRooms] = useState([]);
  const [nameDestination, setNameDestination] = useState("");
  const [selectedValues, setSelectedValues] = useState({});
  const [rates, setRates] = useState([]);
  const [filteredHotels, setFilteredHotels] = useState([]);
  const [markup, setMarkup] = useState("");
  const [paramsUrl, setParamsUrl] = useState({});
  const [totalPax, setTotalPax] = useState(0);
  const [countHotel, setCountHotel] = useState(0);
  const [timer, setTimer] = useState(false);
  const [show, setShow] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const location = useLocation();
  const [sortByPrice, setSortByPrice] = useState(false);
  let requestData = [];
  // Función para parsear los parámetros de la URL
  const parseQueryParams = (query) => {
    return Object.fromEntries(new URLSearchParams(query));
  };
  const queryParams = parseQueryParams(location.search); // Extraemos los parámetros de la URL

  const construirRequest = () => {
    const checkin = queryParams.in; // Fecha de check-in
    const checkout = queryParams.out; // Fecha de check-out
    const id = queryParams.id; // ID del destino
    const tipo = queryParams.t || "destino"; // Tipo de alojamiento
    setSelectedDates([checkin, checkout]);
    // Crear habitaciones a partir de los parámetros pax
    const habitaciones = Object.keys(queryParams)
      .filter((key) => key.startsWith("pax")) // Filtramos las claves que empiezan con 'pax'
      .map((key) => {
        const [adultos, menores, edades] = queryParams[key].split("|");
        return {
          num_adultos: parseInt(adultos, 10),
          num_menores: parseInt(menores, 10),
          edad_menores: edades ? edades.replace(/,/g, "|") : "", // Convertimos comas en pipes
        };
      });

    const totalPersonas = habitaciones.reduce(
      (total, habitacion) =>
        total + habitacion.num_adultos + habitacion.num_menores,
      0
    );

    const habitacionesFormatted = Object.keys(queryParams)
      .filter((key) => key.startsWith("pax")) // Filtramos las claves que empiezan con 'pax'
      .map((key, index) => {
        const [adultos, menores, edades] = queryParams[key].split("|");

        // Convertir edades (si las hay) en un array
        const edadesArray =
          edades === "0" || !edades ? [] : edades.split(",").map(Number);

        // Devolver el objeto con la estructura requerida
        return {
          room: index + 1, // El número de la habitación es el índice + 1
          adults: parseInt(adultos, 10),
          minors: parseInt(menores, 10),
          ages: edadesArray,
        };
      });

    setRooms(habitacionesFormatted);
    setTotalRooms(habitaciones);
    setTotalPax(totalPersonas);

    // Construir el objeto final
    const request = {
      fechas: {
        checkin,
        checkout,
      },
      alojamiento: {
        id,
        tipo,
      },
      habitaciones,
    };

    setParamsUrl(request);

    return request;
  };

  useEffect(() => {
    requestData = construirRequest(); // Esto solo se ejecuta cuando `location.search` cambia
  }, [location.search]);

  useEffect(() => {
    // Obtener la URL actual
    const queryParams = parseQueryParams(location.search);

    // Obtener las fechas de entrada y salida de la URL
    const checkInDate = queryParams.in;
    const checkOutDate = queryParams.out;

    if (checkInDate && checkOutDate) {
      const checkIn = new Date(checkInDate);
      const checkOut = new Date(checkOutDate);
      const timeDifference = checkOut - checkIn;
      const nights = timeDifference / (1000 * 3600 * 24);

      setTotalNights(nights);
    }
  }, [location.search]);

  useEffect(() => {
    const fetchMarkupPanel = async () => {
      try {
        const markupData = await fetchMarkup("hoteleria");
        setMarkup(markupData?.markup);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchMarkupPanel();
  }, []);
  // Llamada combinada para hoteles y tarifas
  useEffect(() => {
    let isMounted = true; // Control de limpieza

    const fetchData = async () => {
      setLoading(true);
      setTimer(false);
      setCountHotel(0);
      try {
        // Paso 1: Cargar y mostrar `hotelsData`
        const hotelsData = await fetchHotels();

        if (isMounted) {
          setFilteredHotels(hotelsData); // Mostrar datos iniciales
          setLoading(false);
        }

        const [ratesData, filtersData] = await Promise.all([
          fetchRates(),
          fetchFilter(),
        ]);
        if (isMounted) {
          if (ratesData.length > 0) {
            setNameDestination(ratesData[0].destino);
          }

          const combinedHotels = hotelsData
            .filter((hotel) =>
              ratesData.some((avail) => avail.code === hotel.id_nativo_bol)
            )
            .map((hotel) => {
              const availability = ratesData.find(
                (avail) => avail.code === hotel.id_nativo_bol
              );
              return { ...hotel, ...availability };
            });

          const filter = combinedHotels.map((hotel) => {
            return hotel.zona;
          });
          let filterBoardName = [];
          let filterBoardCode = [];
          ratesData.forEach((hotelHab) => {
            hotelHab.habitaciones?.forEach((hab) => {
              hab.rates?.forEach((rate) => {
                filterBoardCode.push(rate?.boardCode);
                filterBoardName.push(rate?.boardName);
              });
            });
          });

          const zonasUnicas = [...new Set(filter)];
          const boardNameUnicas = [...new Set(filterBoardName)];
          const boardCodeUnicas = [...new Set(filterBoardCode)];
          const boardData = boardNameUnicas.map((name, index) => ({
            id: boardCodeUnicas[index],
            descripcion: name,
          }));

          setFilteredHotels(combinedHotels); // Actualizar con datos combinados
          setHotels(combinedHotels);
          setCountHotel(ratesData);

          setFilters([
            { nombre: "Plan de Alimentos", lista_filters: boardData, id: 6 },
            ...filtersData,
            { nombre: "Ubicación", lista_filters: zonasUnicas, id: 5 },
          ]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        if (isMounted) console.log("Failed to load data. Please try again.");
      }
    };

    fetchData();

    return () => {
      isMounted = false; // Limpiar al desmontar
    };
  }, [location.search]);

  useEffect(() => {
    setTimeout(() => {
      setTimer(true);
    }, 3000);
  }, [location.search, filteredHotels]);
  // Función para cargar los hoteles
  const fetchHotels = async () => {
    const objAlojamiento = { alojamiento: requestData.alojamiento };

    try {
      const response = await getHotels(objAlojamiento);
      return response;
    } catch (error) {
      console.error("Error fetching hotels:", error);
      return [];
    }
  };

  useEffect(() => {
    const rate = fetchRatesPromotions();
    setRates(rate);
  }, [filteredHotels, location.search]);

  const fetchRatesPromotions = () => {
    const habs = filteredHotels?.map((hotel) => {
      return hotel?.habitaciones?.[0]?.rates?.[0];
    });
    return habs;
  };

  // Función para cargar tarifas
  const fetchRates = async () => {
    try {
      const response = await getHotelAvailability(requestData);
      return response;
    } catch (error) {
      console.error("Error fetching rates:", error);
      return [];
    }
  };
  // Función para cargar filtros de busqueda
  const fetchFilter = async () => {
    try {
      const response = await getHotelFilters(queryParams.id);
      return response;
    } catch (error) {
      console.error("Error fetching rates:", error);
      return [];
    }
  };

  /**
   * Incrementa el número de resultados visibles en 10.
   * @returns {void}
   */
  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 10);
  };

  useEffect(() => {
    // Filtrar hoteles cuando selectedValues cambian
    filterHotels();
  }, [selectedValues, hotels, sortByPrice]);

  // Función para manejar checkboxes
  const handleCheckboxChange = (sectionId, filterId, checked) => {
    setSelectedValues((prev) => {
      const section = prev[sectionId] || [];
      return {
        ...prev,
        [sectionId]: checked
          ? [...section, filterId]
          : section.filter((id) => id !== filterId),
      };
    });
  };

  const getFirstRoomPrice = (hotel) => {
    return hotel.habitaciones?.[0]?.rates?.[0]?.net || Infinity;
  };

  // Función para manejar radios
  const handleRadioChange = (sectionId, filterId) => {
    setSelectedValues((prev) => ({ ...prev, [sectionId]: filterId }));
  };
  // Función para filtrar hoteles
  const filterHotels = () => {
    const hasActiveFilters = Object.values(selectedValues).some((value) => {
      if (value === null) return false;
      if (Array.isArray(value) && value.length === 0) return false;
      return true;
    });

    if (!hasActiveFilters) {
      const sortedHotels = sortByPrice
        ? [...hotels].sort(
            (a, b) => getFirstRoomPrice(a) - getFirstRoomPrice(b)
          )
        : hotels;

      setFilteredHotels(sortedHotels);
      return;
    }

    const filtered = hotels.filter((hotel) => {
      let matches = true;

      // Filtrar por Categoría (radio)
      if (selectedValues[1] && hotel?.categoriaId !== selectedValues[1])
        return false;

      // Filtrar por Plan de Alimentación (checkbox)
      if (selectedValues[2] && selectedValues[2].length > 0) {
        hotel.planes.forEach((element) => {
          matches = matches && selectedValues[2].includes(element);
        });
      }

      // Filtrar por Tipo de Hospedaje (radio)
      if (selectedValues[3]) {
        matches = matches && hotel?.tipo_hospedaje === selectedValues[3];
      }

      // Filtrar por Segmentos (checkbox)
      if (selectedValues[4] && selectedValues[4].length > 0) {
        const segmentosSeleccionados = selectedValues[4].map(Number); // Convertir a números
        matches =
          matches &&
          segmentosSeleccionados.some((segmento) =>
            hotel.segmentos.includes(segmento)
          );
      }
      // Filtrar por Plan de Alimentación (checkbox)
      if (selectedValues[5]) {
        matches = matches && hotel.zona === selectedValues[5];
      }

      if (selectedValues[6] && selectedValues[6].length > 0) {
        let matches_intern = true;
        let end_loop = false;
        for (let i = 0; i < hotel?.habitaciones.length; i++) {
          const habitacion = hotel?.habitaciones[i];
          for (let j = 0; j < habitacion?.rates.length; j++) {
            const rate = habitacion.rates[j];
            if (selectedValues[6].includes(rate.boardCode)) {
              matches_intern = true;
              end_loop = true;
              break;
            } else {
              matches_intern &= false;
            }
          }
          if (end_loop) break;
        }
        matches &= matches_intern;
      }
      return matches;
    });

    const sortedFilteresHotels = sortByPrice
      ? [...filtered].sort(
          (a, b) => getFirstRoomPrice(a) - getFirstRoomPrice(b)
        )
      : filtered;

    setFilteredHotels(sortedFilteresHotels);
  };
  /**
   * Esta función busca un valor numérico al comienzo
   * de la cadena `categoriaId` proporcionada, que representa la
   * calificación de estrellas de una categoría de hotel. Si se encuentra un número, se
   * analiza y se devuelve como un entero. Si no se encuentra ningún número,
   * la función devuelve 0.
   *
   * @param {string} categoriaId - La cadena de identificación de la categoría, que se espera
   * comience con un valor numérico que indique el recuento de estrellas.
   * @returns {number} - El recuento de estrellas extraído o 0 si no se encuentra.
   */

  const getStarCount = (categoria) => {
    const starMatch = categoria?.match(/^(\d+)/); // Busca el número al inicio de la cadena
    return starMatch ? parseInt(starMatch[1], 10) : 0; // Devuelve el número de estrellas
  };

  const HotelStars = ({ categoriaId }) => {
    const totalStars = 5; // Siempre queremos mostrar 5 estrellas
    const starCount = getStarCount(categoriaId); // Obtener el número de estrellas activas
    // Crear un arreglo de 5 estrellas, donde las primeras `starCount` sean destacadas y el resto en gris
    const stars = Array.from({ length: totalStars }, (_, index) =>
      index < starCount ? (
        <FaStar style={{ color: " #0044aa" }} key={index} />
      ) : (
        <FaStar style={{ color: " #000000ff" }} />
      )
    );

    return <div className="section-stars">{stars}</div>;
  };
  const handleSelectHotel = (hotel) => {
    const checkIn = paramsUrl?.fechas?.checkin;
    const checkOut = paramsUrl?.fechas?.checkout;
    const storedArray = rooms;

    const paxParams = storedArray
      .map((hab, index) => {
        const adultos = hab?.adults;
        const menores = hab?.minors;
        const edades = hab?.ages?.length > 0 ? hab?.ages?.join(",") : "0";
        return `pax${index + 1}=${adultos}|${menores}|${edades}`;
      })
      .join("&"); // Unir todos los parámetros de habitaciones con "&"
    let url = `/info-hotel?idHotel=${hotel?.id_atv3}&in=${checkIn}&out=${checkOut}&hab=${storedArray?.length}&${paxParams}`;

    // Usar React Router para redirigir
    window.open(url, "_blank");
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCloseFilters = () => setShowFilters(false);
  const handleShowFilters = () => setShowFilters(true);
  return (
    <div className="alojamientos">
      <div className="results container py-4 py-md-5 py-lg-5">
        {loading && <Loader />}
        <Row>
          <Col lg={3} md={5} sm={12}>
            <div className="modify-search">
              <div className="d-md-block d-none">
                <SearchEngine
                  isSeccionHome={false}
                  isResultsServices={true}
                  alojamientos={true}
                  isModify={true}
                  isHotel={true}
                  totalRooms={totalRooms}
                  totalPersons={[]}
                  isModifyHotel={true}
                  destination={nameDestination}
                  idLocation={queryParams?.id}
                  arrayRooms={rooms}
                  selectedDates={selectedDates}
                />
              </div>
              <Button
                className={[
                  "d-md-none",
                  "d-block",
                  "w-100",
                  "btn-purple",
                  "mt-3",
                  "mb-4",
                  "rounded-4",
                ]}
                style={{ backgroundColor: "#305282", border: "none" }}
                onClick={handleShow}
              >
                Modificar Busqueda
              </Button>

              <Modal show={show} onHide={handleClose}>
                <Modal.Body>
                  <SearchEngine
                    isSeccionHome={false}
                    isResultsServices={true}
                    alojamientos={true}
                    isModify={true}
                    isHotel={true}
                    totalRooms={totalRooms}
                    totalPersons={[]}
                    isModifyHotel={true}
                    destination={nameDestination}
                    idLocation={queryParams?.id}
                    arrayRooms={rooms}
                    selectedDates={selectedDates}
                  />
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
              <Col lg={12} md={12} xs={12}>
                <div
                  className="d-md-block d-none p-4 shadow mt-3 rounded-4"
                  id="filters-tours"
                >
                  <p
                    style={{
                      fontSize: "20px",
                      borderBottom: "2px solid #969696",
                    }}
                  >
                    Filtrar por:
                  </p>
                  {filters && (
                    <Accordion defaultActiveKey="0">
                      <Accordion.Item
                        eventKey="0"
                        className="border-bottom border-2"
                      >
                        <Accordion.Header>
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <p className="m-0">Ordenar Precio</p>{" "}
                            <IoIosArrowDown />
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <Form>
                            <Form.Check
                              type="switch"
                              id="sort-by-price"
                              label="Ordenar de menor a mayor precio"
                              checked={sortByPrice} // Estado que controla el switch
                              onChange={(e) =>
                                setSortByPrice(e?.target?.checked)
                              }
                            />
                          </Form>
                        </Accordion.Body>
                      </Accordion.Item>
                      {filters?.map((filter, index) => (
                        <Accordion.Item
                          eventKey={(index + 1).toString()}
                          key={filter?.id}
                          className="border-bottom border-2"
                        >
                          <Accordion.Header>
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <p className="m-0">{filter?.nombre}</p>{" "}
                              <IoIosArrowDown />
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            <Form>
                              {[
                                "Categoría",
                                "Tipo de Hospedaje",
                                "Ubicación",
                              ]?.includes(filter?.nombre) && (
                                <Form.Group key="all" className="mb-2">
                                  <Form.Check
                                    type="radio"
                                    name={`radio-group-${filter?.id}`}
                                    label="Todos"
                                    id={`${filter?.id}-all`}
                                    checked={!selectedValues[filter?.id]}
                                    onChange={() =>
                                      handleRadioChange(filter?.id, null)
                                    }
                                  />
                                </Form.Group>
                              )}

                              {filter?.lista_filtros?.map((filtro) => (
                                <Form.Group key={filtro?.id} className="mb-2">
                                  {["Segmento"].includes(filter?.nombre) ? (
                                    <Form.Check
                                      type="checkbox"
                                      label={filtro?.descripcion}
                                      id={`${filter?.id}-${filtro?.id}`}
                                      checked={
                                        selectedValues[filter?.id]?.includes(
                                          filtro?.id
                                        ) || false
                                      }
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          filter?.id,
                                          filtro?.id,
                                          e?.target?.checked
                                        )
                                      }
                                    />
                                  ) : (
                                    <Form.Check
                                      type="radio"
                                      name={`radio-group-${filter?.id}`}
                                      label={filtro?.descripcion}
                                      id={`${filter?.id}-${filtro?.id}`}
                                      checked={
                                        selectedValues[filter?.id] ===
                                        filtro?.id
                                      }
                                      onChange={() =>
                                        handleRadioChange(
                                          filter?.id,
                                          filtro?.id
                                        )
                                      }
                                    />
                                  )}
                                </Form.Group>
                              ))}
                              {filter?.lista_filters
                                ?.slice(0, 5)
                                .map((filtro, index) => (
                                  <Form.Group key={index + 1} className="mb-2">
                                    {["Plan de Alimentos"].includes(
                                      filter?.nombre
                                    ) ? (
                                      <Form.Check
                                        type="checkbox"
                                        label={filtro?.descripcion}
                                        id={`${filter?.id}-${filtro?.id}`}
                                        checked={
                                          selectedValues[filter?.id]?.includes(
                                            filtro?.id
                                          ) || false
                                        }
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            filter?.id,
                                            filtro?.id,
                                            e?.target?.checked
                                          )
                                        }
                                      />
                                    ) : (
                                      <Form.Check
                                        type="radio"
                                        name={`radio-group-${filter?.id}`}
                                        label={filtro}
                                        id={`${filter?.id}-${filtro}`}
                                        // label={"Todos"}
                                        checked={
                                          selectedValues[filter?.id] === filtro
                                        }
                                        onChange={() =>
                                          handleRadioChange(filter?.id, filtro)
                                        }
                                      />
                                    )}
                                  </Form.Group>
                                ))}
                            </Form>
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                    </Accordion>
                  )}
                </div>

                <Button
                  className={[
                    "d-md-none",
                    "d-block",
                    "w-100",
                    "btn-purple",
                    "mt-3",
                    "mb-4",
                    "rounded-4",
                  ]}
                  style={{ backgroundColor: "#305282", border: "none" }}
                  onClick={handleShowFilters}
                >
                  Filtros de búsqueda
                </Button>

                <Modal show={showFilters} onHide={handleCloseFilters}>
                  <Modal.Body>
                    {filters && (
                      <Accordion defaultActiveKey="0">
                        <Accordion.Item
                          eventKey="0"
                          className="border-bottom border-2"
                        >
                          <Accordion.Header>
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <p className="m-0">Ordenar Precio</p>{" "}
                              <IoIosArrowDown />
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            <Form>
                              <Form.Check
                                type="switch"
                                id="sort-by-price"
                                label="Ordenar de menor a mayor precio"
                                checked={sortByPrice} // Estado que controla el switch
                                onChange={(e) =>
                                  setSortByPrice(e?.target?.checked)
                                }
                              />
                            </Form>
                          </Accordion.Body>
                        </Accordion.Item>
                        {filters?.map((filter, index) => (
                          <Accordion.Item
                            eventKey={(index + 1).toString()}
                            key={filter?.id}
                            className="border-bottom border-2"
                          >
                            <Accordion.Header>
                              <div className="d-flex justify-content-between align-items-center w-100">
                                <p className="m-0">{filter?.nombre}</p>{" "}
                                <IoIosArrowDown />
                              </div>
                            </Accordion.Header>
                            <Accordion.Body>
                              <Form>
                                {[
                                  "Categoría",
                                  "Tipo de Hospedaje",
                                  "Ubicación",
                                ]?.includes(filter?.nombre) && (
                                  <Form.Group key="all" className="mb-2">
                                    <Form.Check
                                      type="radio"
                                      name={`radio-group-${filter?.id}`}
                                      label="Todos"
                                      id={`${filter?.id}-all`}
                                      checked={!selectedValues[filter?.id]}
                                      onChange={() =>
                                        handleRadioChange(filter?.id, null)
                                      }
                                    />
                                  </Form.Group>
                                )}

                                {filter?.lista_filtros?.map((filtro) => (
                                  <Form.Group key={filtro?.id} className="mb-2">
                                    {["Segmento"].includes(filter?.nombre) ? (
                                      <Form.Check
                                        type="checkbox"
                                        label={filtro?.descripcion}
                                        id={`${filter?.id}-${filtro?.id}`}
                                        checked={
                                          selectedValues[filter?.id]?.includes(
                                            filtro?.id
                                          ) || false
                                        }
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            filter?.id,
                                            filtro?.id,
                                            e?.target?.checked
                                          )
                                        }
                                      />
                                    ) : (
                                      <Form.Check
                                        type="radio"
                                        name={`radio-group-${filter?.id}`}
                                        label={filtro?.descripcion}
                                        id={`${filter?.id}-${filtro?.id}`}
                                        checked={
                                          selectedValues[filter?.id] ===
                                          filtro?.id
                                        }
                                        onChange={() =>
                                          handleRadioChange(
                                            filter?.id,
                                            filtro?.id
                                          )
                                        }
                                      />
                                    )}
                                  </Form.Group>
                                ))}
                                {filter?.lista_filters?.map((filtro, index) => (
                                  <Form.Group key={index + 1} className="mb-2">
                                    {["Plan de Alimentos"].includes(
                                      filter?.nombre
                                    ) ? (
                                      <Form.Check
                                        type="checkbox"
                                        label={filtro?.descripcion}
                                        id={`${filter?.id}-${filtro?.id}`}
                                        checked={
                                          selectedValues[filter?.id]?.includes(
                                            filtro?.id
                                          ) || false
                                        }
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            filter?.id,
                                            filtro?.id,
                                            e?.target?.checked
                                          )
                                        }
                                      />
                                    ) : (
                                      <Form.Check
                                        type="radio"
                                        name={`radio-group-${filter?.id}`}
                                        label={filtro}
                                        id={`${filter?.id}-${filtro}`}
                                        // label={"Todos"}
                                        checked={
                                          selectedValues[filter?.id] === filtro
                                        }
                                        onChange={() =>
                                          handleRadioChange(filter?.id, filtro)
                                        }
                                      />
                                    )}
                                  </Form.Group>
                                ))}
                              </Form>
                            </Accordion.Body>
                          </Accordion.Item>
                        ))}
                      </Accordion>
                    )}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseFilters}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
              </Col>
            </div>

            <div className="py-4 d-md-flex d-none">
              <div className="position-relative">
                <img src={bannerLuckyDay} className="w-100" alt="" />
                <Link
                  to={"/circuitos"}
                  onClick={() => {
                    window.scroll({
                      top: 0,
                      left: 0,
                      behavior: "smooth",
                    });
                  }}
                >
                  <Button
                    type="button"
                    className="btn-blue btn-float-right-hotel rounded-5 lucky-day-hotel"
                  >
                    Hoy es mi día de suerte
                  </Button>
                </Link>
              </div>
            </div>
          </Col>
          {!loading && (
            <>
              <Col lg={8} md={7} sm={12}>
                {/* <div
                  className="container d-md-grid d-none justify-content-start mb-3"
                  id="filters-tours"
                >
                  <h4 className="text-purple" style={{ fontSize: "15px" }}>
                    Filtrar por:
                  </h4>
                  <ButtonGroup className="gap-3">
                    <Button
                      className="btn-filters"
                      onClick={() => handleFilter(0)}
                    >
                      Destacados
                    </Button>
                    <Button
                      className="btn-filters"
                      onClick={() => handleFilter(1)}
                    >
                      Calificación
                    </Button>
                    <Button
                      className="btn-filters"
                      onClick={() => handleFilter(2)}
                    >
                      Todo incluído
                    </Button>
                    <Button
                      className="btn-filters"
                      onClick={() => handleFilter(3)}
                    >
                      Precio
                    </Button>
                  </ButtonGroup>
                </div> */}
                {filteredHotels?.length === 0 && (
                  <Col xl={7} lg={6} md={12} className="mt-3">
                    <div className="text-center mt-5">
                      <h1>0 hoteles disponibles con sus filtros de busqueda</h1>
                      <br />
                      <h2 className="text-muted">
                        No hay hoteles disponibles con estos filtros
                      </h2>
                    </div>
                  </Col>
                )}
                {!loading ? (
                  <Col xl={12} lg={12} md={12} className="p-0 mt-lg-0 mt-3">
                    {countHotel?.length > 0 && timer === true ? (
                      <h4 className="text-lg-start text-center">
                        {filteredHotels?.length} hoteles disponibles
                      </h4>
                    ) : (
                      <Skeleton
                        count={1}
                        height={20}
                        width={200}
                        className="mb-2"
                      />
                    )}
                    {filteredHotels
                      ?.slice(0, visibleCount)
                      ?.map((dataHotel, index) => {
                        return (
                          <div
                            key={index + 1}
                            className="d-flex justify-content-center"
                          >
                            <CardResultHotel
                              nights={totalNights}
                              totalPax={totalPax}
                              percentageMarkup={markup}
                              hotel={dataHotel}
                              visibleHotels={visibleCount}
                              selectHotel={handleSelectHotel}
                            />
                          </div>
                        );
                      })}
                  </Col>
                ) : (
                  <Loader />
                )}
                {visibleCount < filteredHotels.length && (
                  <div className="d-flex justify-content-center w-100">
                    <Button
                      onClick={handleShowMore}
                      className={`btn-blue mt-3 w-25`}
                    >
                      Ver más
                    </Button>
                  </div>
                )}
              </Col>
              <div className="py-0 py-sm-4 py-lg-4 d-md-none d-xs-none d-flex justify-content-center mb-5">
                <div className="position-relative">
                  <img src={bannerLuckyDay} className="w-100" alt="" />
                  <Link
                    to={"/circuitos"}
                    onClick={() => {
                      window.scroll({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                      });
                    }}
                  >
                    <Button
                      type="button"
                      className="btn-blue btn-float-right-hotel rounded-5 lucky-day-hotel"
                    >
                      Hoy es mi día de suerte
                    </Button>
                  </Link>
                </div>
              </div>
            </>
          )}
        </Row>
      </div>

      {/* <CarouselCards
        title={"Encuentra más experiencias aquí"}
        cardsInfo={cardsDestinos}
      /> */}

      <div className="section-about-reservation container py-0 py-sm-5 py-lg-5">
        <SectionAdvise />
      </div>
    </div>
  );
};
